import React from "react";
import { useContent } from '../../services'

const featuredImages = {
    'featured-4.jpg': require('../../assets/images/resource/featured-4.jpg'),
    'featured-5.jpg': require('../../assets/images/resource/featured-5.jpg'),
    'featured-6.jpg': require('../../assets/images/resource/featured-6.jpg'),
    'featured-7.jpg': require('../../assets/images/resource/featured-7.jpg'),
};
const whyIcons = {
    'why-icon-1.png': require('../../assets/images/resource/why-icon-1.png'),
    'why-icon-2.png': require('../../assets/images/resource/why-icon-2.png'),
    'why-icon-3.png': require('../../assets/images/resource/why-icon-3.png'),
    'why-icon-4.png': require('../../assets/images/resource/why-icon-4.png'),
};

function Aboutwhyus() {
  const { data, loading } = useContent('aboutContent');

  if (loading || !data) return null;

  const { whyUs } = data;

  return (
    <>
      <section className="why-us-two">
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle">
              <span>{whyUs.subtitle}</span>
            </div>
            <div className="pattern-image">
              <img src={require('../../assets/images/icons/separator.svg').default} alt="" title="" />
            </div>
            <h2>{whyUs.title}</h2>
          </div>
          <div className="row clearfix">
            {whyUs.items.map((item, index) => (
              <div key={item.id} className={`why-block-two${index % 2 === 1 ? ' m-top' : ''} col-xl-3 col-lg-3 col-md-6 col-sm-12`}>
                <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay={`${index * 300}ms`}>
                  <div className="image-box">
                    <img src={featuredImages[item.image]} alt={item.title} />
                  </div>
                  <div className="over-box">
                    <div className="icon-box">
                      <img src={whyIcons[item.icon]} alt={item.title} />
                    </div>
                    <h4>{item.title}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Aboutwhyus;
